import React from 'react';
import * as Dates from '../utils/Dates';

/**
 * The anchor timestamp of a history/report period navigation, never past now
 * (#320).
 *
 * Next is allowed once the next period has started, then jumps a whole
 * period: Sep 6 on the month scale lands on Oct 6, days after an Oct 3 now,
 * and the year picker anchors on June 1. Zooming in kept such a future
 * instant, so the chart showed a day that had not happened and request sites
 * clamping only their end to now sent end < start. Next only fires once the
 * next period has started, so now lies inside it and the clamp never changes
 * the period; the year picker's current-year June 1 stays in its year. Any
 * other future write is a caller bug, and collapses to now.
 */
const useNavigationTimestamp = () => {
  const [timestamp, setRawTimestamp] = React.useState(Dates.now);

  const setTimestamp = React.useCallback(
    (next: number | ((prev: number) => number)) => {
      setRawTimestamp((prev) =>
        Math.min(typeof next === 'function' ? next(prev) : next, Dates.now()),
      );
    },
    [],
  );

  return [timestamp, setTimestamp] as const;
};

export default useNavigationTimestamp;
